import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobeSimple } from "@phosphor-icons/react";

const LanguageSelector = ({ placement = "down" }) => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const languages = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिन्दी" },
    { code: "kn", label: "ಕನ್ನಡ" },
    { code: "te", label: "తెలుగు" },
    { code: "mr", label: "मराठी" },
  ];

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("edujac_language", language);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={wrapperRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((current) => !current)}
        className="p-2 text-slate-400 hover:text-brand-coral transition-colors duration-200"
        title={t("language.label")}
        aria-label={t("language.change", { defaultValue: "Change language" })}
      >
        <GlobeSimple size={20} />
      </button>

      {open && (
        <div
          className={`absolute right-0 z-[100] min-w-[150px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl ${
            placement === "up" ? "bottom-full mb-2" : "top-full mt-2"
          }`}
        >
          {languages.map((language) => (
            <button
              key={language.code}
              type="button"
              onClick={() => changeLanguage(language.code)}
              className={`block w-full px-4 py-2.5 text-left text-sm transition-colors hover:bg-slate-50 ${
                i18n.language === language.code
                  ? "font-semibold text-brand-coral"
                  : "text-slate-700"
              }`}
            >
              {language.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;